exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-reportLayout-Attachment-preview{vertical-align:middle}.src-components-reportLayout-Attachment-icon{font-size:25px !important}", ""]);

// exports
exports.locals = {
	"preview": "src-components-reportLayout-Attachment-preview",
	"icon": "src-components-reportLayout-Attachment-icon"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportLayout/Attachment/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/reportLayout/Attachment/styles.scss
// module chunks = 1